<template>
  <Head>
    <title>Snow totals Atlas</title>
    <body class="site--snow" />
  </Head>
  <div class="main">
    <div class="section section--atlas">
      <h1 class="section__title">Snow Totals: Atlas</h1>
      <div v-for="state in states" :key="state" class="state">
        <h2 class="state__name">{{ state }}</h2>
        <div class="state__cities">
          <div
            v-for="city in citiesByState(state)"
            :key="city.city"
            class="city"
          >
            <router-link
              :to="{
                name: 'snowTotals',
                query: {
                  lat: `${city.latitude}`,
                  lng: `${city.longitude}`,
                  title: cityNameUrl(city),
                },
              }"
            >
              {{ city.city }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script>
import cities from '@/data/us-cities.json';
import TheFooter from '@/components/TheFooter.vue';
import { Head } from '@vueuse/head';

export default {
  components: { TheFooter, Head },
  data() {
    return {
      cities,
    };
  },
  computed: {
    states() {
      return [...new Set(this.cities.map((city) => city.state))].sort();
    },
  },
  methods: {
    citiesByState(state) {
      return this.cities.filter((city) => city.state === state).sort();
    },
    cityNameUrl(city) {
      return encodeURI(`${city.city}, ${city.state}`);
    },
  },
};
</script>
